// Page Loading Spinner

jQuery(window).load(function() {
    // Animate loader off screen
    jQuery(".preloader-spinner").fadeOut("slow");
});